'use client'

import { HTMLAttributes } from 'react'
import clsx from 'clsx'
import { usePathname, useSearchParams } from 'next/navigation'

import LinkButton, { LinkButtonProps } from 'shared/ui/Button/LinkButton'
import { PATHS } from 'shared/utils/paths'
import { createAsPath } from 'shared/utils/searchParams'

import styles from './DeliveryInfoMenuItemsList.module.scss'

const DeliveryInfoMenuItemsList = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const asPath = createAsPath(pathname, searchParams)

  return (
    <nav className={clsx(styles.menuList, className)} {...props}>
      <StyledLinkButton
        variant='neutralOutline'
        role='link'
        aria-label='Obszary dostawy'
        active={asPath === PATHS.deliveryArea}
        href={PATHS.deliveryArea}
        tabIndex={0}
      >
        Obszary dostawy
      </StyledLinkButton>
      <StyledLinkButton
        variant='neutralOutline'
        role='link'
        aria-label='Terminy i metody dostawy'
        active={asPath === PATHS.deliveryTime}
        href={PATHS.deliveryTime}
        tabIndex={0}
      >
        Terminy i metody dostawy
      </StyledLinkButton>
      <StyledLinkButton
        variant='neutralOutline'
        role='link'
        aria-label='Koszty dostawy'
        active={asPath === PATHS.deliveryCost}
        href={PATHS.deliveryCost}
        tabIndex={0}
      >
        Koszty dostawy
      </StyledLinkButton>
      <StyledLinkButton
        variant='neutralOutline'
        role='link'
        aria-label='Metody płatności'
        active={asPath === PATHS.paymentMethods}
        href={PATHS.paymentMethods}
        tabIndex={0}
      >
        Metody płatności
      </StyledLinkButton>
    </nav>
  )
}

export default DeliveryInfoMenuItemsList

const StyledLinkButton = ({
  active,
  className,
  ...props
}: LinkButtonProps & { active: boolean }) => (
  <LinkButton
    {...props}
    active={active}
    className={clsx(
      styles.linkButton,
      { [styles.linkButtonActive]: active },
      className
    )}
  />
)
